module.exports = __webpack_public_path__ + "img/fouquets.0f00068d.jpg";